import { createServerFn } from "@tanstack/react-start"
import { getRequest } from "@tanstack/react-start/server"
import { z } from "zod"
import { PROJECT_STATUSES } from "@/features/project-status/core/projectStatus"
import {
  assertPermission,
  getAuthenticatedUser,
  getUserStoreRestrictions,
} from "@/lib/assert-permission.server"
import { authFunctionMiddleware } from "@/lib/auth-middleware"
import { queryPresentationLocations } from "./presentationLocationsQuery"

const filtersSchema = z.object({
  status: z.enum(PROJECT_STATUSES),
  countryIds: z.array(z.string()).optional(),
  pageIndex: z.coerce.number().int().min(0).default(0),
  pageSize: z.coerce.number().int().min(1).max(200).default(25),
})

export type PresentationLocationsParams = z.infer<typeof filtersSchema>

export const getPresentationLocationsReport = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .inputValidator((data: unknown) => filtersSchema.parse(data))
  .handler(async ({ data }) => {
    const request = getRequest()
    await assertPermission(request, "project", "read")
    const user = await getAuthenticatedUser(request)
    const restrictions = getUserStoreRestrictions(user)

    return queryPresentationLocations({
      filters: { status: data.status, countryIds: data.countryIds },
      pagination: { pageIndex: data.pageIndex, pageSize: data.pageSize },
      restrictions,
    })
  })
